import Pages from '@pages';
import ParserUtils from '../utils/parser';
import initAppConfig from './config/initAppConfig';
import initCategories from './categories/initCategories';
import initGenres from './genres/initGenres';
import { clearFocus } from '../store/slices/focus.slice';
import { clearModal } from '../store/slices/modal.slice';
import { pushRoute } from '../store/thunks/route.thunk';
import { store } from '../store/store';

/**
 * Initializes the application by updating the session ID, parsing storage,
 * and initializing app configuration, categories, and genres.
 * This function should be called when the application starts.
 */
function initAction() {
  ParserUtils.storageParser();
  initAppConfig();
  initCategories();
  initGenres();
}

/**
 * Handles the login action by clearing focus and modal state,
 * then navigating to the welcome page.
 * This function should be called when a user has the intention to login.
 */
function loginAction() {
  store.dispatch(clearFocus());
  store.dispatch(clearModal());
  store.dispatch(
    pushRoute({
      route: { Page: Pages.LINK },
      params: {
        current: { shouldPop: true },
        push: true,
      },
    })
  );
}

export { initAction, loginAction };
